import { computed, Injectable, signal, Type } from '@angular/core';

export interface OverlayConfig {
    component: Type<unknown>;
    inputs?: Record<string, unknown>;
    closeOnBackdrop?: boolean;
    closeOnEsc?: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class OverlayService {
    private readonly _config = signal<OverlayConfig | null>(null);

    readonly config = this._config.asReadonly();
    readonly isOpen = computed(() => this._config() !== null);

    open(config: OverlayConfig): void {
        this._config.set(config);
    }

    close(): void {
        this._config.set(null);
    }
}
